export default function getPercentCompleteLockedReason(
  row,
) {
  if (
    row.Operation && row.Operation.OpComplete
  ) {
    return 'OP_COMPLETE'
  }
}